import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
   const userData =useSelector((state) => state.auth.user)
  const token = useSelector((state) => state.auth.token);
       
      if(userData.roleID == 0 || userData.roleID == 1 && token == null){
        return token ? children : <Navigate to="/adminlogin" />;
      }else{
        return token ? children : <Navigate to="/login" />;
      }
};

export default PrivateRoute;
